import { types } from 'mobx-state-tree';
import { Dashboard } from '../features/dashboard/models';
import { Jobs } from '../features/jobs';
import { ClientsStore } from '../features/clients';

export const IndependentRecruiters = types.model({
  dashboard: types.optional(Dashboard, {}),
  jobs: types.optional(Jobs, {}),
  clients: types.optional(ClientsStore, {})
});
